import { routes } from '~/routes';
import { useDomainWhitelisted } from './useDomainWhitelisted';

export const useDomainRedirection = () => {
  const { isWhitelisted, targetUrl } = useDomainWhitelisted();

  const onOpenNewSite = () => {
    if (!isWhitelisted || !targetUrl) return;

    window.open(targetUrl, '_blank');
  };

  const onOpenResetPassword = () => {
    if (!isWhitelisted || !targetUrl) return;

    window.open(`${targetUrl}${routes.signUpRedesign.forgotPassword}`, '_blank');
  };

  return { onOpenNewSite, onOpenResetPassword };
};
